import {
  Box,
  Button,
  FormControl,
  Paper,
  Stack,
  TextField,
  Typography,
  Divider,
  Grid,
  colors,
} from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
//import * as yup from "yup";
import yup from "./../../util/yupExtended";
import { addMethod, StringSchema } from "yup";
import { SubmitHandler, useForm } from "react-hook-form";
import { Address, Customer } from "../../API";
import {
  ResourceOperation,
  useApplicationStore,
} from "../../context/ApplicationStoreContext";
import { useEffect } from "react";
import liff from "@line/liff/dist/lib";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { PostalRepository } from "../../DAL/repositories/PostalRepository";
import { color } from "@mui/system";
import { calcShippingFee } from "../../util/ShippingFee";

type CustomerInfoForm = {
  destination: Address;
  customer: Customer;
};

const phoneRegExp = /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/gi;
const postalRegExp = /^[0-9]{3}[0-9]{4}$/gi;

const formSchema = yup.object({
  destination: yup.object().shape({
    postal_code: yup
      .string()
      .trimPostal()
      .matches(postalRegExp, "郵便番号の形式に誤りがあります。")
      .required("郵便番号の入力は必須です。"),
    pref: yup.string().required("都道府県の入力は必須です。"),
    city: yup.string().required("市区町村の入力は必須です。"),
    town: yup.string().required("町域名の入力は必須です。"),
    address1: yup.string(),
    address2: yup.string(),
  }),
  customer: yup.object().shape({
    id: yup.string().required(),
    name: yup.string().required("氏名の入力は必須です。"),
    email: yup
      .string()
      .email("メールアドレスの形式が異なります。")
      .required("メールアドレスの入力は必須です。"),
    phone: yup
      .string()
      .trimPhoneNumber()
      .matches(phoneRegExp, "電話番号の形式に誤りがあります。")
      .required("電話番号の入力は必須です。"),
  }),
});

const CustomerInfo = () => {
  const {
    register,
    setValue,
    formState: { errors },
    trigger,
    getValues,
    handleSubmit,
  } = useForm<CustomerInfoForm>({
    resolver: yupResolver(formSchema),
    defaultValues: {},
  });
  const { state, dispatch } = useApplicationStore();
  const onSubmit: SubmitHandler<CustomerInfoForm> = (data) => {
    const customer = data.customer;
    if (typeof customer.address === "undefined") customer.address = [];
    customer.address?.push(data.destination);
    dispatch({ type: ResourceOperation.VALIDATED_CUSTOMER, payload: customer });
    dispatch({ type: ResourceOperation.ADD_INDEX });
  };

  useEffect(() => {
    setValue("customer.id", state.customer?.id!);
    if (state.customer?.lineId !== "") {
      setValue("customer.lineId", state.customer?.lineId!);
    } else {
      liff.getProfile().then((result) => {
        setValue("customer.lineId", result.userId);
      });
    }
    setValue("customer.name", state.customer?.name!);
    setValue("customer.email", state.customer?.email!);
    setValue("customer.phone", state.customer?.phone!);
    setValue("customer.address", state.customer?.address!);
    if (state.customer?.address && state.customer?.address.length > 0) {
      setValue(
        "destination",
        state.customer?.address[state.customer?.destinationIndex || 0]!
      );
      dispatch({
        type: ResourceOperation.CALC_SHIPPING_FEE,
        payload: calcShippingFee(
          state.orderInfoForm?.total!,
          state.customer.address[state.customer?.destinationIndex || 0]?.pref!
        ),
      });
    }
  }, [state.customer]);
  return (
    <>
      <Stack spacing={2}>
        <Paper elevation={0} variant="outlined">
          <Stack spacing={1} p={2}>
            <Typography variant="body1">お客さまの情報</Typography>
            <Divider variant="middle" />
            <FormControl sx={{ width: "100%" }}>
              <TextField
                
                margin="dense"
                id="customer_name"
                label="氏名"
                variant="filled"
                required
                fullWidth
                {...register("customer.name")}
                error={"customer.name" in errors}
                placeholder="氏名"
                // @ts-ignore
                helperText={errors.customer?.name?.message}
              />
            </FormControl>
            <FormControl sx={{ width: "100%" }}>
              <TextField
                
                margin="dense"
                id="customer_phone"
                label="電話番号"
                variant="filled"
                required
                fullWidth
                {...register("customer.phone")}
                error={"customer.phone" in errors}
                placeholder="電話番号"
                // @ts-ignore
                helperText={errors.customer?.phone?.message}
              />
            </FormControl>
            <FormControl sx={{ width: "100%" }}>
              <TextField
                
                margin="dense"
                id="customer_email"
                label="メールアドレス"
                variant="filled"
                required
                fullWidth
                {...register("customer.email")}
                error={"customer.email" in errors}
                placeholder="example@example.com"
                // @ts-ignore
                helperText={errors.customer?.email?.message}
              />
            </FormControl>
          </Stack>
        </Paper>
        <Paper elevation={0} variant="outlined">
          <Stack spacing={1.5} p={2} pb={3}>
            <Typography variant="body1">お届け先住所</Typography>
            <Divider variant="middle" />
            <Grid container alignItems="center" columnGap={2}>
              <Grid item>
                <FormControl>
                  <TextField
                    sx={{ width: 160 }}
                    
                    margin="dense"
                    id="postal_code"
                    label="郵便番号"
                    variant="filled"
                    required
                    fullWidth
                    {...register("destination.postal_code")}
                    error={"destination.postal_code" in errors}
                    placeholder="郵便番号"
                    // @ts-ignore
                    helperText={errors.destination?.postal_code?.message}
                  />
                </FormControl>
              </Grid>
              <Grid item>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    trigger("destination.postal_code")
                      .then((hasNoError) => {
                        return new Promise<string>((res, rej) => {
                          if (hasNoError) {
                            const code = getValues(
                              "destination.postal_code"
                            ).replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi, "");
                            res(code);
                          } else {
                            rej();
                          }
                        });
                      })
                      .then(PostalRepository().search)
                      .then((r) => {
                        dispatch({
                          type: ResourceOperation.CALC_SHIPPING_FEE,
                          payload: calcShippingFee(
                            state.orderInfoForm?.total!,
                            //@ts-ignore
                            r.pref
                          ),
                        });
                        //@ts-ignore
                        setValue("destination.pref", r.pref);
                        //@ts-ignore
                        setValue("destination.city", r.city);
                        //@ts-ignore
                        setValue("destination.town", r.town);
                      });
                  }}
                >
                  住所検索
                </Button>
              </Grid>
            </Grid>

            <TextField
              margin="dense"
              id="pref"
              label="都道府県"
              variant="outlined"
              disabled
              required
              fullWidth
              focused
              {...register("destination.pref")}
              error={"destination.pref" in errors}
              placeholder="都道府県"
              // @ts-ignore
              helperText={errors.destination?.pref?.message}
            />

            <TextField
              
              margin="dense"
              id="city"
              label="市区町村"
              required
              disabled
              focused
              fullWidth
              variant="outlined"
              {...register("destination.city")}
              error={"destination.city" in errors}
              placeholder="名前"
              // @ts-ignore
              helperText={errors.destination?.city?.message}
            />

            <TextField
              
              margin="dense"
              id="town"
              label="町域名"
              required
              disabled
              focused
              fullWidth
              variant="outlined"
              {...register("destination.town")}
              error={"address.town" in errors}
              placeholder="町域名"
              // @ts-ignore
              helperText={errors.destination?.town?.message}
            />
            <TextField
              
              margin="dense"
              id="address1"
              label="丁目・番地・号"
              required
              fullWidth
              variant="filled"
              {...register("destination.address1")}
              error={"address.address1" in errors}
              placeholder="丁目・番地・号"
              // @ts-ignore
              helperText={errors.destination?.address1?.message}
            />
            <TextField
              
              margin="dense"
              id="address2"
              label="建物名"
              fullWidth
              variant="filled"
              {...register("destination.address2")}
              error={"address.address2" in errors}
              placeholder="建物名"
              // @ts-ignore
              helperText={errors.destination?.address2?.message}
            />
          </Stack>
        </Paper>

        <Box sx={{ mb: 2 }}>
          <div>
            <Button
              variant="contained"
              onClick={handleSubmit(onSubmit)}
              sx={{ mt: 1, mr: 1 }}
            >
              次へ
            </Button>
            <Button
              onClick={() => dispatch({ type: ResourceOperation.SUB_INDEX })}
              sx={{ mt: 1, mr: 1 }}
            >
              戻る
            </Button>
          </div>
        </Box>
      </Stack>
    </>
  );
};

export default CustomerInfo;
